package com.gsb.vyapar.bhagya.presentation.common.expandablelist

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.ExperimentalMaterialApi
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.saveable.Saver
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.snapshots.SnapshotStateMap
import androidx.compose.runtime.toMutableStateMap
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.Business
import com.gsb.vyapar.bhagya.domain.User
import com.gsb.vyapar.bhagya.domain.getEmail
import com.gsb.vyapar.bhagya.domain.getFirstName
import com.gsb.vyapar.bhagya.domain.getImage
import com.gsb.vyapar.bhagya.domain.getLastName
import com.gsb.vyapar.bhagya.domain.getMobile
import com.gsb.vyapar.bhagya.domain.getPhone1
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.business.util.launchAddEditMBusiness
import com.gsb.vyapar.bhagya.presentation.business.view.BusinessCardFull
import com.gsb.vyapar.bhagya.presentation.common.image.BusinessCardPlaceHolder
import com.gsb.vyapar.bhagya.theme.arrow_down
import com.gsb.vyapar.bhagya.theme.arrow_up
import org.jetbrains.compose.resources.painterResource
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImageRound
import com.gsb.vyapar.bhagya.presentation.common.image.PlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.SocialPlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.SmoothImageRound
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularBBStart
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.call
import com.gsb.vyapar.bhagya.theme.mail
import com.gsb.vyapar.bhagya.theme.offwhite
import com.gsb.vyapar.bhagya.theme.whatsapp
import com.gsb.vyapar.bhagya.util.BLANK_PROFILE
import com.gsb.vyapar.bhagya.util.getMobile
import com.gsb.vyapar.bhagya.util.value

data class SectionData(val user: User, val businesses: List<Business>)

@Composable
fun ExpandableList(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit, sections: List<SectionData>) {
    val isExpandedMap = rememberSavableSnapshotStateMap {
        List(sections.size) { index: Int -> index to false }
            .toMutableStateMap()
    }
    LazyColumn(
        content = {
            sections.onEachIndexed { index, sectionData ->
                Section(
                    uiState,
                    onTriggerEvent,
                    sectionData = sectionData,
                    isExpanded = isExpandedMap[index] ?: false,
                    onHeaderClick = {
                        isExpandedMap[index] = !(isExpandedMap[index] ?: false)
                    }
                )
            }
        }
    )
}

@OptIn(ExperimentalMaterialApi::class)
@Composable
fun SectionHeader(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit,sectionData: SectionData, isExpanded: Boolean, onHeaderClicked: () -> Unit) {
    val uriHandler = LocalUriHandler.current
    Card(
        modifier = Modifier.fillMaxWidth(),
        shape = RoundedCornerShape(8.dp),
        backgroundColor = offwhite,
        onClick = { onHeaderClicked() }
    ) {
        Row(modifier = Modifier
            .clickable { onHeaderClicked() }
            .padding(vertical = 8.dp, horizontal = 16.dp)) {
            Row(modifier = Modifier.weight(1.0f)) {
                SmoothImageRound(
                    uiState.getImage(sectionData.user.getImage().ifEmpty { BLANK_PROFILE.value() }),
                    width = 80.dp,
                    height = 80.dp
                )
                Spacer(Modifier.width(15.dp))
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.Center
                ) {
                    Text14RegularBBStart("${sectionData.user.getFirstName()} ${sectionData.user.getLastName()}", black)
                    Text14RegularBBStart(sectionData.user.getMobile(), black)
                    Text14RegularBBStart(sectionData.user.getEmail(), black)
                    Spacer(Modifier.height(8.dp))
                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly, verticalAlignment = Alignment.CenterVertically) {
                        SocialPlaceHolder(whatsapp, modifier = Modifier.clickable { uriHandler.openUri("https://wa.me/+91${sectionData.user.getMobile()}") })
                        BusinessCardPlaceHolder(call, modifier = Modifier.clickable { uriHandler.openUri("tel:${sectionData.user.getMobile()}") })
                        BusinessCardPlaceHolder(mail, modifier = Modifier.clickable { uriHandler.openUri("mailto:${sectionData.user.getEmail()}") })
                    }
                    Spacer(Modifier.height(8.dp))
                }
            }
            if (sectionData.businesses.isNotEmpty()) {
                if (isExpanded) {
                    CommonImage(painterResource(arrow_up))
                } else {
                    CommonImage(painterResource(arrow_down))
                }
            }
        }
    }
}

fun LazyListScope.Section(
    uiState: UiState,
    onTriggerEvent: (UiEvents) -> Unit,
    sectionData: SectionData,
    isExpanded: Boolean,
    onHeaderClick: () -> Unit
) {
    item {
        Column(Modifier.fillMaxWidth().padding(8.dp)) {
            SectionHeader(
                uiState,
                onTriggerEvent,
                sectionData = sectionData,
                isExpanded = isExpanded,
                onHeaderClicked = onHeaderClick
            )
        }
    }
    if (isExpanded) {
        items(sectionData.businesses) {
            Column(Modifier.fillMaxWidth().padding(horizontal = 8.dp)) {
                BusinessCardFull(uiState, onTriggerEvent, it) {
                    launchAddEditMBusiness(it)
                }
            }
            Spacer(Modifier.height(8.dp))
        }
    }
}

@Composable
fun <K, V> rememberSavableSnapshotStateMap(init: () -> SnapshotStateMap<K, V>): SnapshotStateMap<K, V> =
    rememberSaveable(saver = snapshotStateMapSaver(), init = init)

fun <K, V> snapshotStateMapSaver() = Saver<SnapshotStateMap<K, V>, Any>(
    save = { state -> state.toList() },
    restore = { value ->
        @Suppress("UNCHECKED_CAST")
        (value as? List<Pair<K, V>>)?.toMutableStateMap() ?: mutableStateMapOf<K, V>()
    }
)